import { FC, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { ISearchPageProps } from './types';

import { ItemsWithoutFilters } from '../../components';

import { PageWrapperWithCommonBlocks } from 'src/components';
import { removeCurrentData, saveCurrentPaginationPage } from 'src/models';

export const SearchPage: FC<ISearchPageProps> = ({ className = '', ...rest }) => {
  const { t } = useTranslation();

  useEffect(() => {
    removeCurrentData();
    saveCurrentPaginationPage(1);
  }, []);

  return (
    <PageWrapperWithCommonBlocks className={className} {...rest}>
      <ItemsWithoutFilters title={t('items.search-title')} isSearchPage />
    </PageWrapperWithCommonBlocks>
  );
};
